module.exports = __webpack_public_path__ + "static/media/uph_0003.b381bf28.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/uph_0003.jpg
// module id = 634
// module chunks = 0